module.exports = __webpack_public_path__ + "img/page-ico.7846fb10.png";